import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center mb-5" }, "How many ways a ball can fall down a stair.", -1)
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "Steps:", -1)
const _hoisted_4 = { class: "steps-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Step = _resolveComponent("Step")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (!_ctx.simulating)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Start",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleStart()))
            }))
          : _createCommentVNode("", true),
        (_ctx.simulating)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: "Stop",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.simulating = false)),
              class: "p-button-danger"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_InputNumber, {
          modelValue: _ctx.requestedNumberOfSteps,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestedNumberOfSteps) = $event)),
          min: 2,
          max: 100,
          showButtons: ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "step-positioner",
        style: _normalizeStyle({ width: _ctx.width, height: _ctx.width })
      }, [
        _createVNode(_component_Step, { idx: 0 })
      ], 4)
    ])
  ], 64))
}